<template>
  <div ref="component" class="simple cx_style deng">
    <div>
      <!-- 字体和颜色 -->
      <div class="verticallyCenter">
        <el-select v-model="fontFamilyVal" class="mr8 flex1 height32" ref="">
          <el-option
            v-for="(item, index) in fontFamilyList"
            :key="index"
            :selected="fontFamilyVal == item.value"
            :value="item.value"
            :label="item.title"
            >{{ item.title }}
          </el-option>
        </el-select>
        <div class="number-input-box width72">
          <single-input
            class="percent100"
            :value.sync="originFontSizeVal"
            inputSuffixs="px"
          />
        </div>
      </div>
      <!--字重和字号 -->
      <div class="mt8 verticallyCenter">
        <el-select v-model="fontWeightVal" class="mr8 flex1" ref="">
          <el-option
            v-for="(item, index) in fontWeightList"
            :key="index"
            :selected="fontWeightVal == item.value"
            :value="item.value"
            :label="item.title"
            >{{ item.title }}
          </el-option>
        </el-select>
        <!--        <div class="color-picker-container inlineMiddle percent38 w78">-->
        <div class="color-picker-container inlineMiddle width72">
          <el-color-picker
            :popper-append-to-body="false"
            v-model="fontColorVal"
            :show-alpha="true"
            :predefine="predefineColors"
            @active-change="activeChangeColor"
          ></el-color-picker>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "../common.css"
import publicData from "../mixins/publicData.js"

export default {
  mixins: [ publicData],
  name: "textSetting",
  props: {
    fontWeight: {
      type: [String, Number],
      required: true
    },
    fontSize: {
      type: Number,
      required: true
    },
    fontFamily: {
      type: String,
      required: true
    },
    fontColor: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      // fontSizeVal:0,
      fontFamilyList: [
        {
          label: "默认字体",
          value: "sans-serif"
        },
        {
          label: "钉钉进步体",
          value: "钉钉进步体"
        },
        {
          label: "方正",
          value: "方正"
        },
        {
          label: "方正正大黑简体",
          value: "方正正大黑简体"
        },
        {
          label: "联想小新潮酷体",
          value: "联想小新潮酷体"
        },
        {
          label: "庞门正道标题",
          value: "庞门正道标题"
        },
        {
          label: "思源黑体",
          value: "SourceHanSansCN"
        },
        {
          label: "思源宋体",
          value: "SourceHanSerifCN"
        },
        {
          label: "优设标题黑",
          value: "YouSheBiaoTiHei"
        },
        {
          label: "Alata",
          value: "Alata"
        },
        {
          label: "D-din",
          value: "D-din"
        },
        {
          label: "D-din Condensed",
          value: "D-din Condensed"
        },
        {
          label: "D-din Exp",
          value: "D-din Exp"
        },
        {
          label: "Raleway",
          value: "Raleway"
        },
        {
          label: "Roboto-Regular",
          value: "Roboto-Regular"
        },
        {
          label: "Roboto-Black",
          value: "Roboto-Black"
        }
      ],
      fontWeightList: [
        {
          title: "细体",
          value: 200
        },
        {
          title: "常规体",
          value: 400
        },
        {
          title: "粗体",
          value: 700
        },
        {
          title: "加粗体",
          value: 900
        }
      ]
    }
  },
  // watch:{
  //   ids: {
  //     handler: function (newVal, oldVal) {
  //       this.fontSizeVal = this.originFontSizeVal
  //     },
  //     immediate: true,
  //     deep: true
  //   },
  //   originFontSizeVal(newVal, oldVal){
  //     if (newVal !== oldVal) {
  //       this.fontSizeVal = newVal
  //     }
  //   },
  // },
  mounted(){
    // this.fontSizeVal = this.originFontSizeVal
  },
  computed: {
    fontWeightVal: {
      get() {
        return this.fontWeight
      },
      set(val) {
        this.$emit("update:fontWeight", val)
      }
    },
    originFontSizeVal: {
      get() {
        return this.fontSize
      },
      set(val) {
        this.$emit("update:fontSize", Number(val))
      }
    },
    fontFamilyVal: {
      get() {
        return this.fontFamily || "sans-serif"
      },
      set(val) {
        this.$emit("update:fontFamily", val)
      }
    },
    fontColorVal: {
      get() {
        return this.fontColor
      },
      set(val) {
        this.$emit("update:fontColor", val)
      }
    }
  },
  methods: {
    // getFocus(event) {
    //   event.currentTarget.select()
    // },
    activeChangeColor(val) {
      this.fontColorVal = val
    },
    // setValue(originName,name){
    //   if(this[name]){
    //     this[originName] = Number(this[name])
    //   }else{
    //     // 不允许输入为空 为空的情况恢复原来的值
    //     this[name] = Number(this[originName])
    //   }
    // }
  }
}
</script>

<style scoped>
.percent42 {
  width: 42%;
}
.width72 {
  width: 72px;
}
</style>
